import { tokens } from "../../context/weet-tokens.js";
const inputThemeConfig = {
    tokens: {
        activeBorderColor: tokens.weetColorBorderSelect,
        activeShadow: 'none',
        addonBg: '#ffffff',
        errorActiveShadow: 'none',
        hoverBorderColor: tokens.weetColorBorderBrandHover,
        inputFontSizeLG: 14,
        warningActiveShadow: 'none'
    }
};
export { inputThemeConfig };
